export const truncate = (str, characters) => {
  if (str.length > characters) {
    return `${str.substring(0, characters - 3)}...`
  }

  return str
}
